// extracted by mini-css-extract-plugin
export default {"box":"egmZVnY2HSeZ__tIOaL2"};